{
  "dropdown": {
    "account": "Account",
    "signIn": "Sign in",
    "telekomIdTitle": "Telekom ID",
    "profileSettings": "Profile settings",
    "signInWithAnother": "Sign in with another account",
    "logout": "Sign out",
    "close": "Close"
  },
  "chatbot": {
    "welcome": "Welcome",
    "continueAs": "Continue as ",
    "beginChatConnected": "Begin your chat connected<br/>with <0>Telekom id {{telekomIdNumber}}</0>",
    "needConnectionRegistered": "To help you with an existing connection, it needs to be registered in the connections you manage. If you want to add your connection, click <0>here</0>."
  }
}
